import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Evento, Persona, Spettacolo } from '../../../../shared/interface';

@Component({
  selector: 'app-personale-accredito-spettacolo-backoffice',
  templateUrl: './personale-accredito-spettacolo-backoffice.component.html',
  styleUrl: './personale-accredito-spettacolo-backoffice.component.css'
})
export class PersonaleAccreditoSpettacoloBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}  
  
  spettacolo?: Spettacolo;
  evento?: Evento;  
  personale: Persona[] = [];

  loading: boolean = false;
  
  ngOnInit(): void {
  
    this.route.params.subscribe((params) => {
      const id = params['id'];

      this.loading = true;

      this.apiService.getSpettacolo(id).subscribe({
        next: (data) => this.spettacolo = data,
        error: (err) => this.router.navigate(['/backoffice/spettacoli']),
        complete: () => {
      
          this.apiService.getEventoSpettacolo(id).subscribe({
            next: (data) => this.evento = data,
            error: (err) => this.router.navigate(['/backoffice/spettacoli']),
            complete: () => {

              this.apiService.getPersonaleEvento(this.evento?.id!).subscribe({
                next: (data) => [...data.map(persona => this.personale.push(persona))],
                error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                complete: () => {   
                  this.loading = false;
                }
              })
            
            }
          })   
        
        }
      })
  
    })
  }

}
